import { PieceType, TeamType } from '../../Types';
import { Piece, Position } from '../../models';

export const tileIsOccupied = (
    position: Position,
    boardState: Piece[]
): boolean =>
{   
    const piece = boardState.find(
        (p) => p.samePosition(position)
    );

    if (piece) {
        return true;
    }
    else {
        return false;
    }
}

export const tileIsOccupiedByOpponent = (
    position: Position, 
    boardState: Piece[], 
    team: TeamType
): boolean =>
{
    const piece = boardState.find(
        (p) => p.samePosition(position) && p.team !== team);
    if (piece){
        return true;
    }
    else {
        return false;
    }
}

export const tileIsEmptyOrOccupiedByOpponent = (
    position: Position,
    boardState: Piece[],
    team: TeamType
) => {
    return(
        !tileIsOccupied(position, boardState) ||
        tileIsOccupiedByOpponent(position, boardState, team)
    )
}

export const isEnPassantMove = (
    initialPosition: Position,
    desiredPosition: Position,
    type: PieceType,
    team: TeamType,
    boardState: Piece[]
) => {

    const pawnDirection = team === TeamType.OUR ? 1 : -1;

    if (type === PieceType.PAWN){
        if ((desiredPosition.x - initialPosition.x === -1 || 
            desiredPosition.x - initialPosition.x === 1) && 
            desiredPosition.y - initialPosition.y === pawnDirection ) {
            const piece = boardState.find(
                (p) => 
                    p.position.x === desiredPosition.x && 
                    p.position.y === desiredPosition.y - pawnDirection && 
                    p.enPassant
            );

            if(piece){
                return true;
            }
        }
    }
    return false;
}
